

















module.exports =
  props: ['event']

  data: ->
    moment: moment

  methods:
    liveFeedEventDescription: ->
      switch @event.detailed_type
        when 'EmailEvent-open' then 'leu um email'
        when 'EmailEvent-reply' then 'respondeu um email'
        when 'EmailEvent-bounce' then 'não recebeu um email'

    toggleTaskBar: (contact) ->
      event.originalEventName = 'toggle-task-bar'
      @$emit 'toggle-task-bar', { event, contact }




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/manual_tasks/live_feed_event_list_item.vue